import { useAppDispatch, useAppSelector } from "app/hooks";
import LayersApi from "components/PanelSettings/components/Layers/layersApi";
import { addFeatures } from "features/krpano/details-slice";
import { useEffect } from "react";
import { addKrpanoHotspot, addKrpanoHotspotLayer } from "shared/helpers/krpano";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

type UseGetLayers = (krpanoFeaturesReady: boolean) => void;

/**
 * # Get Overpass API Layers for krpano
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useGetLayers: UseGetLayers = (krpanoFeaturesReady) => {
  const dispatch = useAppDispatch();
  // const [loading, setLoading] = useState<boolean>(false);

  const guid = useAppSelector((state) => state.panorama.guid);
  const currentFieldId = useAppSelector(
    (state) => state.panorama.currentFieldDetails?.fid
  );

  useEffect(() => {
    const getLayers = async (
      params: Parameters<typeof LayersApi.getLayer>[0]
    ) => {
      // setLoading(true);
      const response = await LayersApi.getLayer(params);
      // setLoading(false);
      if (response.success && response.data) {
        // Add layers to Redux
        dispatch(addFeatures(response.data));
        response.data.forEach((group, groupIndex) => {
          group.children.forEach((layer, layerIndex) => {
            const layerName = layer.targetLayer;
            // Add points to krpano
            const layerShape = addKrpanoHotspot(
              layerName,
              {
                // Group
                group: group.groupName,
                onclick: `loadFeature(${groupIndex}, ${layerIndex}, ${layerName});`,
                // Additional keys for polygon
                ...(layer.type === "polygon" && {
                  polyline: false,
                }),
                // Additional keys for point
                ...(layer.type === "point" && {
                  atv: layer.points[0].atv,
                  ath: layer.points[0].ath,
                }),
              },
              layer.type === "point" ? "Feature_Point" : "Feature_Line"
            );
            // Create Layer shape if not a point
            if (layer.type !== "point") {
              addKrpanoHotspotLayer(layerShape, layer.points);
            }
          });
          if (group.visible) {
            // Set initial visibility of group
            window.krpano.call(
              `visibilityByGroup(${group.groupName}, ${group.visible});`
            );
          }
        });
      } else {
        // TODO: Error handling
        console.warn("Error loading layers", response.errors);
      }
    };

    if (krpanoFeaturesReady && guid && notNullNorUndefined(currentFieldId)) {
      getLayers({
        currentFieldID: currentFieldId,
        panoramaGuid: guid,
      });
    }
  }, [krpanoFeaturesReady, dispatch, currentFieldId, guid]);
};
